import * as React from 'react';
import Header from '../../components/header';
import CoursesService, { Course, CourseType, CaseUserAssignment, ScenarioLearningStatus, ScenarioLearningStatusNames } from '../../services/CoursesService';
import { Col, Container, Row, Tabs, Tab, Accordion, Card, Button } from 'react-bootstrap';
import { Link, NavLink, Redirect } from 'react-router-dom';
import { AppRoute } from '../../definitions/routes';
import {MouseEvent} from 'react';

interface ICoursesTabProps {
  courses: Array<Course>
  onCourseClick: (course: Course) => void
}


interface ICoursesTabState { }

class CoursesTab extends React.Component<ICoursesTabProps, ICoursesTabState> {
  constructor(props: ICoursesTabProps) {
    super(props);

    this.state = { }
  }

  public render() {
    return (
      <div>
        <Accordion>
          {this.props.courses.map((course, index) => 

            <Card key={index}>
              <Accordion.Toggle as={Card.Header} eventKey={index.toString()} style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                {course.name} {course.author && course.author.name ? `(${course.author.name})` : ''}<Button className="pull-right" onClick={() => this.props.onCourseClick(course)}>Начать</Button>
              </Accordion.Toggle>              
            <Accordion.Collapse eventKey={index.toString()}>
              <Card.Body>
                <div dangerouslySetInnerHTML={{__html: (course.text || '') as string}}></div>
              </Card.Body>
            </Accordion.Collapse>
            </Card>
          )}
        </Accordion>          
      </div>
    );
  }
}

interface IAssignmentsProps {
  assignments: Array<CaseUserAssignment>,
  onCourseClick: (course: CaseUserAssignment) => void
}

function status(st: keyof ScenarioLearningStatus): string
{
    return st;
}

class AssignmentsTab extends React.Component<IAssignmentsProps> {
  constructor(props: IAssignmentsProps) {
    super(props);

    this.state = { }
  }

  public render() {
    return (
      <div>
        <Accordion>
          {this.props.assignments.map((ass, index) => 

            <Card key={index}>
              <Accordion.Toggle as={Card.Header} eventKey={index.toString()} style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                {`${ass.course.name} (${ScenarioLearningStatusNames[ass.status]})`} {/*ass.course.author && ass.course.author.name ? `(${course.author.name})` : ''*/}
                {ass.status.toString() === 'STARTED' ? <Button className="pull-right" onClick={() => this.props.onCourseClick(ass)}>Продолжить</Button> : null }
                {ass.status.toString() === 'WAIT_FOR_ASSESSMENT' ? <Button className="pull-right" onClick={() => this.props.onCourseClick(ass)}>Оценить</Button> : null }
                {ass.status.toString() === 'FINISHED' ? <Button className="pull-right" onClick={() => this.props.onCourseClick(ass)}>Результат</Button> : null }
              </Accordion.Toggle>              
            <Accordion.Collapse eventKey={index.toString()}>
              <Card.Body>
                <div dangerouslySetInnerHTML={{__html: (ass.course.text || '') as string}}></div>
              </Card.Body>
            </Accordion.Collapse>
            </Card>
          )}
        </Accordion>          
      </div>
    );
  }
}

export interface ICoursesProps { }

export interface ICoursesState {
  assignedCourses: Array<CaseUserAssignment>,
  availableCourses: Array<Course>,
  redirectToCreatedScenarioAssignment: Number,
  redirectToCreatedOpenAssignment: Number
}

export default class Courses extends React.Component<ICoursesProps, ICoursesState> {
  
  constructor(props: ICoursesProps) {
    super(props);

    this.state = {
      assignedCourses: [],
      availableCourses: [],
      redirectToCreatedScenarioAssignment: 0,
      redirectToCreatedOpenAssignment: 0
    }
  }

  async componentDidMount () {
    try {
      let availableCourses = await CoursesService.getAvailable();
      let assignedCourses = await CoursesService.getAssignedCourses();//availableCourses.filter(course => course.type == CourseType.OPEN);
      this.setState({
        availableCourses,
        assignedCourses
      });
    } catch(err) {}
  }
  
  assignCourseAndStartLearning = async (course: Course) => {
    try {
      let courseUserAssignmentId = await CoursesService.assignCourse(course.id);
      if (courseUserAssignmentId) {
        if (course.type == CourseType.SCENARIO) {
          this.setState({redirectToCreatedScenarioAssignment: courseUserAssignmentId});
        } else if (course.type == CourseType.OPEN) {
          this.setState({redirectToCreatedOpenAssignment: courseUserAssignmentId});
        }
      } else {
        throw new Error("Error creation assignment.");
      }
    } catch(err) {}
  }

  proceedCourse = async (ass: CaseUserAssignment) => {
    if (ass.course.type == CourseType.SCENARIO) {
      this.setState({redirectToCreatedScenarioAssignment: ass.id});
    } else if (ass.course.type == CourseType.OPEN) {
      this.setState({redirectToCreatedOpenAssignment: ass.id});
    }
  };

  public render() {
    return (
      <div>
        <Header title="Прохождение курсов" />
        <Container>
          <Row>
            <Col md={12}>
              <Tabs defaultActiveKey="scenarioCourses" id="courses-tab">
                <Tab eventKey="scenarioCourses" title="Доступные курсы">
                  <CoursesTab courses={this.state.availableCourses} onCourseClick={this.assignCourseAndStartLearning} />
                </Tab>
                <Tab eventKey="assignedCourses" title="Назначенные курсы">
                  <AssignmentsTab assignments={this.state.assignedCourses}  onCourseClick={this.proceedCourse}/>
                </Tab>
              </Tabs>
              {this.state.redirectToCreatedScenarioAssignment > 0 ?
                <Redirect to={`${AppRoute.CASES}/${this.state.redirectToCreatedScenarioAssignment}`}></Redirect>
              :null}
              {this.state.redirectToCreatedOpenAssignment > 0 ?
                <Redirect to={`${AppRoute.GROUP_TESTING}/${this.state.redirectToCreatedOpenAssignment}`}></Redirect>
              :null}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
